import React from 'react'

import Bot from './bot/Bot'

function App({ settings }) {
  return <Bot {...settings} />
}

export default App
